export default {
  'emailLog.title': 'Email Logs',
  'emailLog.form.merchant': 'Merchant',
  'emailLog.form.merchant.placeholder': 'Select merchant',
  'emailLog.form.shopifyId': 'Shopify ID',
  'emailLog.form.shopifyId.placeholder': 'Shopify ID',
  'emailLog.form.toEmail': 'Recipient Email',
  'emailLog.form.toEmail.placeholder': 'Recipient email',
  'emailLog.form.contentType': 'Template Type',
  'emailLog.form.contentType.placeholder': 'Select template type',
  'emailLog.form.status': 'Send Status',
  'emailLog.form.status.placeholder': 'Select send status',
  'emailLog.form.isRead': 'Read Status',
  'emailLog.form.isRead.placeholder': 'Select read status',
  'emailLog.form.dateRange': 'Created At',
  'emailLog.form.startDate': 'Start Date',
  'emailLog.form.endDate': 'End Date',
  'emailLog.form.search': 'Search',
  'emailLog.form.reset': 'Reset',
  'emailLog.columns.index': '#',
  'emailLog.columns.merchant': 'Merchant',
  'emailLog.columns.shopifyId': 'Shopify ID',
  'emailLog.columns.toEmail': 'Recipient',
  'emailLog.columns.subject': 'Subject',
  'emailLog.columns.contentType': 'Template Type',
  'emailLog.columns.status': 'Send Status',
  'emailLog.columns.isRead': 'Read Status',
  'emailLog.columns.retryCount': 'Retry Count',
  'emailLog.columns.errorMessage': 'Error Message',
  'emailLog.columns.messageId': 'Message ID',
  'emailLog.columns.createdAt': 'Created At',
  'emailLog.columns.sentAt': 'Sent At',
  'emailLog.columns.readAt': 'Read At',
  'emailLog.columns.operations': 'Actions',
  'emailLog.columns.operations.view': 'Detail',
  'emailLog.status.sending': 'Sending',
  'emailLog.status.success': 'Success',
  'emailLog.status.failed': 'Failed',
  'emailLog.isRead.unread': 'Unread',
  'emailLog.isRead.read': 'Read',
  'emailLog.detail.title': 'Email Detail',
  'emailLog.detail.content': 'Content',
  'emailLog.detail.config': 'Config',
  'emailLog.detail.response': 'Response',
  'emailLog.detail.responseCode': 'Response Code',
  'emailLog.detail.errorMessage': 'Error Message',
  'emailLog.detail.updatedAt': 'Updated At',
  'emailLog.detail.empty': 'No content',
};
